<template>
  <div id="fy_container_contact" class="parent_container">
    <div class="child_container" :class="{'contact_reverse': product.isReverse}">
      <div class="contact_way">
        <h2 v-for="(h2,h2Index) in product.title" :key="'contact_h2' + h2Index">{{h2}}</h2>
        <img src="https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pc/imgs/contact/wechat.png">
      </div>
      <img :src="product.imgSrc">
    </div>
  </div>
</template>

<script>
  import './../assets/css/fy_container_contact.css'

    export default {
        name: "fy_container_contact",
        props: ['product']
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/fy_container_contact.vue